import {
  faSun,
  faTachometerAlt,
  faWater,
  faBolt,
  faThermometerHalf,
  faVial,
  faBatteryThreeQuarters,
  faPlug,
  faPlane,
  faSatellite,
  faPlaneArrival,
  faMountain,
  faTasks,
  faCompass,
  faGaugeHigh,
  faMicrochip,
  faSignal,
  faChartLine
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ICON_STYLE = { fontSize: 36 };

export function toMeasurementKey(title) {
  const cleaned = title.replace(/\s+/g, '');
  return cleaned.charAt(0).toLowerCase() + cleaned.slice(1);
}

export function matchSensingData(synfieldData, sids) {
  return synfieldData.map(item => {
    const svc = sids.find(s => s.id === item.sensing_service_id);
    if (!svc) {
      return {
        id:    item.sensing_service_id,
        title: `Unknown ${item.sensing_service_id}`,
        unit:  '',
        value: item.value ?? 'N/A',
        icon:  <FontAwesomeIcon icon={faBolt} style={ICON_STYLE} />
      };
    }
    return {
      id:    svc.id,
      title: svc.name,
      unit:  svc.units,
      value: `${item.value} ${svc.units}`,
      icon:  <FontAwesomeIcon icon={faBolt} style={ICON_STYLE} />
    };
  });
}

export function getSystemIcon(title) {
  switch (title) {
    case 'Battery':
    case 'Battery Voltage':
      return <FontAwesomeIcon icon={faBatteryThreeQuarters} style={ICON_STYLE} />;
    case 'Current':
      return <FontAwesomeIcon icon={faPlug} style={ICON_STYLE} />;
    case 'System temperature':
    case 'System Temperature':
    case 'CPU Temperature':
      return <FontAwesomeIcon icon={faThermometerHalf} style={ICON_STYLE} />;
    case 'Signal Strength':
      return <FontAwesomeIcon icon={faSignal} style={ICON_STYLE} />;
    case 'Roll':
    case 'Pitch':
    case 'Yaw':
      return <FontAwesomeIcon icon={faCompass} style={ICON_STYLE} />;
    case 'Velocity':
      return <FontAwesomeIcon icon={faGaugeHigh} style={ICON_STYLE} />;
    case 'IMU':
      return <FontAwesomeIcon icon={faMicrochip} style={ICON_STYLE} />;
    default:
      return <FontAwesomeIcon icon={faBolt} style={ICON_STYLE} />;
  }
}

export function getDashboardIcon(title) {
  switch (title) {
    case 'Solar radiation level':
    case 'Solar Radiation Level':
      return <FontAwesomeIcon icon={faSun} style={ICON_STYLE} />;
    case 'Barometric Pressure':
      return <FontAwesomeIcon icon={faTachometerAlt} style={ICON_STYLE} />;
    case 'Soil Moisture':
      return <FontAwesomeIcon icon={faWater} style={ICON_STYLE} />;
    case 'Soil Temperature':
      return <FontAwesomeIcon icon={faThermometerHalf} style={ICON_STYLE} />;
    case 'Electrical Conductivity':
      return <FontAwesomeIcon icon={faBolt} style={ICON_STYLE} />;
    case 'Irrigation':
      return <FontAwesomeIcon icon={faVial} style={ICON_STYLE} />;
    case 'Flight Mode':
      return <FontAwesomeIcon icon={faPlane} style={ICON_STYLE} />;
    case 'GPS Satellites':
      return <FontAwesomeIcon icon={faSatellite} style={ICON_STYLE} />;
    case 'Landed State':
      return <FontAwesomeIcon icon={faPlaneArrival} style={ICON_STYLE} />;
    case 'Altitude':
      return <FontAwesomeIcon icon={faMountain} style={ICON_STYLE} />;
    case 'Mission Progress':
      return <FontAwesomeIcon icon={faTasks} style={ICON_STYLE} />;
    default:
      return <FontAwesomeIcon icon={faBolt} style={ICON_STYLE} />;
  }
}

export function getMeasurementIcon(key) {
  switch (key) {
    case 'attitude':
      return <FontAwesomeIcon icon={faCompass} />;
    case 'velocity':
      return <FontAwesomeIcon icon={faGaugeHigh} />;
    case 'imu':
      return <FontAwesomeIcon icon={faMicrochip} />;
    case 'solarRadiationLevel':
      return <FontAwesomeIcon icon={faSun} />;
    case 'barometricPressure':
      return <FontAwesomeIcon icon={faTachometerAlt} />;
    case 'soilMoisture':
      return <FontAwesomeIcon icon={faWater} />;
    case 'electricalConductivity':
      return <FontAwesomeIcon icon={faBolt} />;
    case 'waterContent':
      return <FontAwesomeIcon icon={faVial} />;
    case 'soilTemperature':
      return <FontAwesomeIcon icon={faThermometerHalf} />;
    default:
      return <FontAwesomeIcon icon={faChartLine} />;
  }
}
